export default __webpack_public_path__ + "static/automobile-mega-shopper-8346ad3fd5fd03b70872721fc7bd2a2d.gif";